import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import {
  PaymentAdminDetailSchema,
  PaymentAdminSchema,
} from "../../Schemas/Payment";

interface Filter extends IFilterSchema {
  column: PaymentAdListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: PaymentAdListColumnSortable;
}

export enum PaymentAdVerifyingStatusEnum {
  PENDING = "pending",
  PAYING = "paying",
  PAID = "paid",
  FAILED = "failed",
}

export enum PaymentAdListColumnFilterable {
  USER_ID = "user_id",
  ID = "id",
  NAME = "name",
  CAPTION = "caption",
  DISK = "disk",
  TYPE = "type",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}
export enum PaymentAdListColumnSortable {
  ID = "id",
  NAME = "name",
  CAPTION = "caption",
  DISK = "disk",
  TYPE = "type",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}



interface PaymentListResponseBody extends IResponseBody {
  data: {
    payment_receipt: PaymentAdminDetailSchema;
  };
}

export class PaymentAdminDetailRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(receiptId: number) {
    return `/admin/payment-receipts/${receiptId}`;
  }

  async send(receiptId: number): Promise<PaymentListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(receiptId)
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
